import React from "react"
import tw, { css, styled } from "twin.macro"

export interface LearnDetailItem {
  title?: string
  text: string[]
}

interface Props {
  items: LearnDetailItem[]
}

const LearnDetail: React.FC<Props> = ({ items }) => {
  return (
    <ItemsWrapper>
      {items.map((item, index) => (
        <Item key={index}>
          {/* Title if we have one */}
          {!!item.title && <Heading>{item.title}</Heading>}
          {/* Render each text item to a paragraph */}
          {item.text.map((paragraph, index) => <Paragraph css={[css`text-align: left;`]} key={index} dangerouslySetInnerHTML={{__html: paragraph}} />)}
        </Item>
      ))}
    </ItemsWrapper>
  )
}

const ItemsWrapper = styled.div`
  font-family: Interstate; font-size: 13px; line-height: 21px; font-weight: 300;
  ${tw`flex flex-wrap flex-row md:px-8 md:py-4 text-center text-black`}
`

const Item = styled.div`
  ${css`max-width: 26rem;
  @media (max-width: 768px) {
    margin: auto;
  }`},
  ${tw`w-full md:w-1/2 text-sm p-4 md:p-16`}
`

const Heading = styled.h2`
font-size: 20px; line-height: 20px; letter-spacing: -0.5px; font-weight: 700;
  ${tw`mb-6`}
`

const Paragraph = styled.p`
  ${tw`mb-6`}
`

export default LearnDetail
